<template>
	<v-menu		
        :ref 					= "'menu' + reference"
        v-model 				= "menu"
        :close-on-content-click = "false"
        transition 				= "scale-transition"
        offset-y
        min-width 				= "auto"
      >
        <template v-slot:activator="{ on, attrs }">
	        <v-text-field
	            chips
	            dense
	            outlined
	            readonly
          		clearable
	            multiple		
	            small-chips
	            hide-details
	            v-model 			= "inputField[keyField]"
	          	:label              = "$ml.get(text)"
	            :placeholder        = "$ml.get(placeholder)"
	            prepend-inner-icon 	= "mdi-calendar"
	            v-bind 				= "attrs"
	            v-on 				= "on"
	        ></v-text-field>

        </template>
        <v-date-picker
          	dense
          	no-title
          	scrollable
          	:range 		= "isRange"
          	v-model 	= "inputField[keyField]"
          	@change 	= "renderDate()" 
        		@input 		= "isInput ? renderDate() : ''" 
        >
	        <v-btn
	        	x-small
	        	outlined	            
	        	v-text = "$ml.get('cancel')"
	          color  = "error"
	          @click = "cancelDate()"
	        ></v-btn>
          	<v-spacer></v-spacer>
	        <v-btn
	          x-small	            
	          outlined
	          v-text  = "$ml.get('confirm')"
	          color   = "primary"
	          @click  = "renderDate()"
	        ></v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script type="text/javascript">
	export default{
		name: "MenuDate",
		props:{
			inputField : { type : Object, required: true } ,
			keyField : { type : String, required: true },
			text : { type : String },
			placeholder : { type : String },
			isInput : { type : Boolean, default : false},
			isRange : { type : Boolean, default : false},
			reference : String,
		},
		data: () => ({
			menu 		 	: false,
			dates 		 	: [], 	
		}),
		methods:{
			renderDate(){
				if (this.inputField && this.inputField[this.keyField]) {	
					if (this.isRange) {
						this.inputField[this.keyField].sort((a,b)=> new Date(a) - new Date(b) );							
					}					
					this.cancelDate();				
				}else{
					console.warn("Not receive info item to send date / time : ", this.inputField[this.keyField]);
				}				
			}, // render search

			cancelDate(){
				this.menu=false
			},
		},
	}
</script>